var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutsSecureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5284 22.341H7.62926C4.35952 22.341 2.17969 20.7062 2.17969 16.8915V9.26207C2.17969 5.44737 4.35952 3.8125 7.62926 3.8125H18.5284C21.7981 3.8125 23.978 5.44737 23.978 9.26207V16.8915C23.978 20.7062 21.7981 22.341 18.5284 22.341Z",
    stroke: "#1E247E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0783 16.3471C14.8842 16.3471 16.3481 14.8832 16.3481 13.0774C16.3481 11.2715 14.8842 9.80762 13.0783 9.80762C11.2725 9.80762 9.80859 11.2715 9.80859 13.0774C9.80859 14.8832 11.2725 16.3471 13.0783 16.3471Z",
    stroke: "#DA867D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17969 9.80699H3.2696C6.53934 9.80699 7.62926 8.71708 7.62926 5.44734V4.35742",
    stroke: "#1E247E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9769 9.80699H22.887C19.6173 9.80699 18.5273 8.71708 18.5273 5.44734V4.35742",
    stroke: "#1E247E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17969 16.3467H3.2696C6.53934 16.3467 7.62926 17.4366 7.62926 20.7063V21.7963",
    stroke: "#1E247E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9769 16.3467H22.887C19.6173 16.3467 18.5273 17.4366 18.5273 20.7063V21.7963",
    stroke: "#1E247E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 29.1094C20.5468 27.8371 17.4766 23.7669 17.4766 19.1356V14.0629L24.9998 11.9134L32.523 14.0629V19.1356C32.523 23.7669 29.4529 27.8371 24.9998 29.1094Z",
    fill: "#ECF1F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9981 26.1523C22.0744 25.317 20.0586 22.6447 20.0586 19.6039V16.2734L24.9981 14.8621L29.9375 16.2734V19.6039C29.9375 22.6447 27.9218 25.317 24.9981 26.1523Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 1.34365,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8789 20.5116L24.2902 21.9229L27.1127 19.1003",
    stroke: "#1E247E",
    strokeWidth: 1.34365,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutsSecureIcon);
export default __webpack_public_path__ + "static/media/PayoutsSecureIcon.f7ab53f1889d352a2e585f2795e87b2b.svg";
export { ForwardRef as ReactComponent };